import AxiosLib from "./lib/http-axios-lib";
import UserService from "./../services/user-service";
const _request = (method, url, data, isJson = true, binaryResponse = false) => {
  let options = {
    method: method,
    url: url,
    responseType: binaryResponse ? "blob" : "json",
  };
  if (data && method === "GET") {
    options.params = data;
  } else if (data) {
    options.data = data;
    if (isJson) {
      options.headers = {
        "Content-Type": "application/json",
      };
    } else {
      options.headers = { "Content-Type": "multipart/form-data" };
    }
  }
  return new Promise((resolve, reject) => {
    AxiosLib.request(options)
      .then((response) => {
        let data = response.data;
        if (typeof data != "object") {
          data = JSON.parse(data);
        }
        resolve(data);
      })
      .catch((error) => {
        if (error && error.response && error.response.status) {
          if (error.response.status === 401) {
            // if (
            //   error.response.data &&
            //   error.response.data.message &&
            //   error.response.data.message === "Error: Token Expired"
            // ) {
              window.location.reload();
            // }
            UserService.signOut();
          } else if (error.response.status === 403) {
          } else if (error.response.status === 500) {
          }
        } else {
        }

        reject(error);
      });
  });
};

const DataAccessService = {
  get(url, data, isJson = true, binaryResponse = false) {
    return _request("GET", url, data, isJson, binaryResponse);
  },
  post(url, data, isJson = true, binaryResponse = false) {
    return _request("POST", url, data, isJson, binaryResponse);
  },
  delete(url) {
    return _request("DELETE", url);
  },
  put(url, data) {
    return _request("PUT", url, data);
  },
};

export default DataAccessService;
